<template>
  <v-app v-resize="onResize">
    <v-main>
      <v-toolbar height="60" flat color="transparent" class="no-print">
        <!-- <v-app-bar-nav-icon class="hidden-md-and-up" @click.stop="drawer = !drawer"></v-app-bar-nav-icon> -->
        <template v-for="(item, index) in menuItems">
          <template v-if="checkNotice(item)">
            <v-toolbar-items v-if="checkAvailable(item)" :key="index">
            <!-- <v-toolbar-items v-if="checkAvailable(item)" :key="index" class="hidden-sm-and-down"> -->
              <v-sheet class="pa-2" width="66" color="transparent" :key="index">
                <v-row class="ma-0" align="center">
                  <v-col v-if="item.badge" cols="12" class="pa-0">
                    <v-row class="ma-0" align="center">
                      <v-col cols="12" class="pa-0" align="center">
                        <v-badge overlap :color="unRead != 0 ? 'red' : 'transparent'">
                          <span v-if="unRead != 0" slot="badge">{{ unRead }}</span>
                          <v-btn icon small class="pa-0 ma-0" @click="onGoto('/chat')">
                            <v-icon :color="getPrimaryColor(item)" size="28">mood</v-icon>
                          </v-btn>
                        </v-badge>
                      </v-col>
                      <v-col cols="12" class="pa-0" align="center">
                        <span class="caption sheet-footer-text" text-center>{{ item.title }}</span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col v-else cols="12" class="pa-0" align="center">
                    <v-row class="ma-0" align="center">
                      <v-col cols="12" class="pa-0" align="center">
                        <template v-if="item.path != '/'">
                          <v-btn icon small class="pa-0 ma-0" color="transparent" @click="item.func(item.path)">
                            <v-icon :color="getPrimaryColor(item)" size="28">{{ item.icon }}</v-icon>
                          </v-btn>
                        </template>
                        <template v-else>
                          <v-btn icon small class="pa-0 ma-0" color="transparent" @click="item.func(item.path)">
                            <v-avatar v-if="data" size="28">
                              <img v-if="checkSchoolAvatar()" :src="checkSchoolAvatar()" :style="$route.path != item.path ? 'opacity: 0.5;' : 'opacity: 1;'" >
                              <v-avatar v-else size="28" color="primary"><span class="font-weight-bold white--text" style="font-size:20px; user-select: none;">{{ getNamePrefixFromItem() }}</span></v-avatar>
                            </v-avatar>
                            <v-icon v-else :color="getPrimaryColor(item)" size="28">{{ item.icon }}</v-icon>
                          </v-btn>
                        </template>
                      </v-col>
                      <v-col cols="12" class="pa-0" align="center">
                        <span @click="item.func(item.path)" class="caption sheet-footer-text" text-center>{{ item.title }}</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-toolbar-items>
          </template>
          <v-spacer v-if="item.divider" :key="item.title"></v-spacer>
        </template>
      </v-toolbar>
      <!-- <v-navigation-drawer
        v-model="drawer"
        absolute
        temporary
        class="elevation-0 no-print">
        <v-list dense>
          <template v-for="(item, index) in menuItems">
            <v-list-item
              :key="item.title"
              @click="item.func(item.path)"
            >
              <v-list-item-action>
                <v-icon :class="item.iconColor">{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
                <v-spacer></v-spacer>
              <v-list-item-action v-if="item.badge" class="pr-2">
                <v-icon small color="error">{{ item.bIcon }}</v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="item.divider" :key="index"></v-divider>
          </template>
        </v-list>
      </v-navigation-drawer> -->

      <template v-if="data">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </template>
      <template v-else>
        <router-view></router-view>
      </template>

      <v-footer v-if="!loading" :color="$vuetify.theme.dark ? 'black' : 'white'" height="40" class="no-print">
        <v-row class="ma-0" align="center" justify="center">
          <template v-if="checkPrimary() == false">
            <v-col cols="4" class="pa-0 hidden-sm-and-down">
              <v-row align="center" justify="center" class="ma-0 pa-0">
                <v-img v-if="checkServer()" class="hidden-sm-and-down" max-width="60px" :src="require('./assets/realte-logo.png')"></v-img>
                <span class="font-weight-light overflow-text-hidden" style="font-size:10px;">©2023 Freewill Total Education All Rights Reserved.</span>
              </v-row>
            </v-col>
            <v-col cols="auto" class="pa-0" align="center">
              <v-row align="center" class="ma-0 pa-0">
                <v-col class="py-0" align="center">
                  <v-btn x-small depressed rounded outlined @click.stop="tospp = true, type = 'tos'" class="primary--text">利用規約</v-btn>
                </v-col>
                <v-col class="py-0" align="center">
                  <v-btn x-small depressed rounded outlined @click.stop="tospp = true, type = 'pp'" class="primary--text">個人情報保護方針</v-btn>
                </v-col>
                <v-col class="py-0" align="center">
                  <v-btn x-small depressed rounded outlined @click.stop="onGotoHome()" class="primary--text">運営会社</v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="4" class="pa-0 hidden-sm-and-down" align="center">
              <span class="font-weight-light" style="font-size:10px;">Developed by. UBUNIFU Inc.</span>
            </v-col>
          </template>
          <template v-else>
            <v-chip class="font-weight-bold" color="error">危険：他塾モードで動作中。新規・変更・削除等、他塾データの変更は厳禁</v-chip>
          </template>
        </v-row>
      </v-footer>
    </v-main>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='ログアウト'
        message="ログアウトしますがよろしいですか?"
        :dialog='dialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <v-dialog v-model="tospp"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-tos-pp
          @dismissed="onDismissed"
          :dialog='tospp'
          :type='type'
          :close="true"
        >
        </app-tos-pp>
      </v-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-app>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'
import BasicDialog from './components/BasicDialog.vue'
import AvatarSelector from './components/avatar/AvatarSelector'
import TosPP from './components/TosPP.vue'
import StudentDialog from './components/student/StudentDialog.vue'
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import moment from 'moment-timezone'
import Alert from './components/Alert.vue'
import Loading from './components/Loading.vue'
import Memo from './components/student/TemplateMemo.vue'

Vue.component('app-loading', Loading)
Vue.component('RecycleScroller', RecycleScroller)
Vue.component('v-avatar-selector', AvatarSelector)
Vue.component('app-basic-dialog', BasicDialog)
Vue.component('app-tos-pp', TosPP)
Vue.component('app-student-dialog', StudentDialog)
Vue.component('app-alert', Alert)
Vue.component('template-memo', Memo)

export default {
  name: 'App',
  computed: {
    ...mapGetters({
      version: 'shared/version',
      user: 'auth/user',
      data: 'auth/data',
      shutdown: 'auth/shutdown',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      error: 'shared/error',
      loading: 'shared/loading',
      privilege: 'shared/privilege',
      school: 'shared/school',
      chatRef: 'chatRef/chatRef',
      chatUnread: 'chatUnread/chatRef',
      initial: 'auth/initial',
      maintenance: 'shared/maintenance'
    }),
    isUserAuthenticated () {
      var user = JSON.parse(JSON.stringify(this.user))
      if (user) {
        return user !== undefined
      }
      return false
    },
    isMaintenance () {
      if (this.maintenance && this.maintenance.state) {
        return true
      }
      return false
    },
    menuItems () {
      if (this.isUserAuthenticated) {
        var index = this.users.findIndex(user => user.key === this.user.uid)
        if (index === -1) {
          return this.itemsNoUser
        }
        if (!this.users[index].registered) {
          return this.itemsNoUser
        }
        if (this.data && this.getPrivilegesLevel(this.data) === 0) {
          return this.itemsAdmin
        } else if (this.maintenance && this.maintenance.state) {
          if (this.data.role !== 'admin') {
            return this.itemsMaintenance
          } else {
            return this.itemsMaintenanceAdmin
          }
        }
        return this.items
      } else if (this.maintenance && this.maintenance.state) {
        return this.itemsMaintenance
      } else {
        return this.itemsLogin
      }
    },
    unRead () {
      var unread = 0
      for (var x in this.chatRef) {
        var ref = this.chatRef[x]
        if (this.data && this.checkMember(ref)) {
          var index = this.chatUnread.findIndex(c => c.key === ref.location)
          if (index !== -1) {
            if (typeof this.chatUnread[index].unread[this.user.uid] !== 'undefined') {
              unread += this.chatUnread[index].unread[this.user.uid]
            } else if (typeof this.chatUnread[index].total !== 'undefined') {
              unread += this.chatUnread[index].total
            }
          }
        }
      }
      if (unread > 99) {
        unread = 99
      }
      return unread
    }
  },
  data () {
    return {
      drawer: false,
      dialog: false,
      doingMonitor: false,
      tospp: false,
      type: null,
      itemsLogin: [
        { title: 'Home',
          icon: 'dashboard',
          path: '/',
          iconColor: 'primary--text',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: true,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        },
        // { title: '問合せ',
        //   icon: 'email',
        //   iconColor: 'primary--text',
        //   path: '/contact',
        //   func: this.onGoto,
        //   badge: false,
        //   bFunc: null,
        //   divider: false,
        //   disable: false,
        //   primary: false,
        //   roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        // },
        { title: 'ログイン',
          icon: 'mdi-login',
          iconColor: 'primary--text',
          path: '/signin',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        },
        { title: '新規登録',
          icon: 'account_circle',
          iconColor: 'primary--text',
          path: '/signup',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        }
      ],
      itemsMaintenance: [
        { title: 'Home',
          icon: 'dashboard',
          path: '/',
          iconColor: 'primary--text',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: true,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        },
        { title: 'ログイン',
          icon: 'mdi-login',
          iconColor: 'primary--text',
          path: '/signin',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        }
      ],
      itemsMaintenanceAdmin: [
        { title: 'Home',
          icon: 'dashboard',
          path: '/',
          iconColor: 'primary--text',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: true,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        },
        { title: '設定',
          icon: 'mdi-settings',
          iconColor: 'success--text',
          path: '/setting',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        }
        // { title: 'Logout',
        //   icon: 'mdi-logout',
        //   iconColor: 'error--text',
        //   path: '',
        //   func: this.onLogoutDialog,
        //   badge: false,
        //   bFunc: null,
        //   divider: false,
        //   disable: false,
        //   primary: false,
        //   roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        // }
      ],
      itemsAdmin: [
        { title: 'Home',
          icon: 'dashboard',
          path: '/',
          iconColor: 'primary--text',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: false, teacher: false, user: false }
        },
        { title: '塾',
          icon: 'school',
          path: '/school',
          iconColor: 'primary--text',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        },
        { title: '認証',
          icon: 'mdi-shield-account',
          path: '/account',
          iconColor: 'secondary--text',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        },
        { title: 'ユーザ',
          icon: 'mdi-shield-account',
          path: '/users',
          iconColor: 'secondary--text',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: true,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        },
        { title: '管理',
          icon: 'warning',
          iconColor: 'success--text',
          path: '/sandbox',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: false, chief: false, teacher: false, user: false }
        },
        { title: '告知',
          icon: 'mdi-information',
          iconColor: 'success--text',
          path: '/notice',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: false, teacher: false, user: false }
        },
        { title: '設定',
          icon: 'mdi-settings',
          iconColor: 'success--text',
          path: '/setting',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        }
        // { title: 'Logout',
        //   icon: 'mdi-logout',
        //   iconColor: 'error--text',
        //   path: '',
        //   func: this.onLogoutDialog,
        //   badge: false,
        //   bFunc: null,
        //   divider: false,
        //   disable: false,
        //   primary: false,
        //   roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        // }
      ],
      itemsNoUser: [
        { title: 'Home',
          icon: 'dashboard',
          path: '/',
          iconColor: 'secondary--text',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: true,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        },
        { title: '設定',
          icon: 'mdi-settings',
          iconColor: 'success--text',
          path: '/setting',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        }
        // { title: 'Logout',
        //   icon: 'mdi-logout',
        //   iconColor: 'error--text',
        //   path: '',
        //   func: this.onLogoutDialog,
        //   badge: false,
        //   bFunc: null,
        //   divider: false,
        //   disable: false,
        //   primary: false,
        //   roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        // }
      ],
      items: [
        { title: 'Home',
          icon: 'dashboard',
          iconColor: 'primary--text',
          path: '/',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        },
        { title: '生徒',
          icon: 'school',
          iconColor: 'primary--text',
          path: '/students',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: false }
        },
        { title: '伝言',
          icon: 'mood',
          iconColor: 'primary--text',
          path: '/chat',
          func: this.onGoto,
          badge: true,
          bIcon: 'mdi-bell',
          bFunc: null,
          divider: false,
          disable: false,
          primary: true,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        },
        { title: '計画',
          icon: 'work',
          iconColor: 'primary--text',
          path: '/schedule',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        },
        { title: '共有',
          icon: 'share',
          iconColor: 'primary--text',
          path: '/share',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: true,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        },
        { title: '分析',
          icon: 'insert_chart',
          iconColor: 'primary--text',
          path: '/progress',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: false, user: false }
        },
        { title: '目標',
          icon: 'mdi-arrow-top-right-thick',
          iconColor: 'success--text',
          path: '/plan',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: false, user: false }
        },
        { title: '診断',
          icon: 'mdi-hospital',
          iconColor: 'error--text',
          path: '/diagnose',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: false, owner: false, chief: false, teacher: false, user: false }
        },
        { title: '資料',
          icon: 'mdi-folder-google-drive',
          iconColor: 'success--text',
          path: '/drive',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: true,
          roles: { admin: false, owner: false, chief: false, teacher: false, user: false }
        },
        { title: '告知',
          icon: 'mdi-information',
          iconColor: 'success--text',
          path: '/notice',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: false, teacher: false, user: false }
        },
        { title: '設定',
          icon: 'mdi-settings',
          iconColor: 'success--text',
          path: '/setting',
          func: this.onGoto,
          badge: false,
          bFunc: null,
          divider: false,
          disable: false,
          primary: false,
          roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        }
        // { title: 'Logout',
        //   icon: 'mdi-logout',
        //   iconColor: 'error--text',
        //   path: '',
        //   func: this.onLogoutDialog,
        //   badge: false,
        //   bFunc: null,
        //   divider: false,
        //   disable: false,
        //   primary: false,
        //   roles: { admin: true, owner: true, chief: true, teacher: true, user: true }
        // }
      ]
    }
  },
  watch: {
    maintenance (nV, oV) {
      if (oV && nV.state !== oV.state) {
        if (nV.state) {
          this.onLogout()
        }
      } else if (nV.state) {
        this.onLogout()
      }
    },
    data () {
      var vm = this
      if (this.data) {
        if (this.data.schools[localStorage.school]) {
          if (!this.initial) {
            this.$store.dispatch('auth/get', vm.getSchool()).then(() => {
              this.changeGrade(this)
              vm.goto(vm, '/')
            })
          }
        } else if (!this.shutdown) {
          if (firebase.auth().currentUser) {
            vm.$store.dispatch('auth/init').then(() => {
              firebase.auth().signOut().then(function () {
                vm.$store.dispatch('shared/setError', new Error('入力された利用者登録IDではログイン出来ません。再度ご確認ください。'))
              }).catch(function (error) {
                if (error) {
                  // console.log(error)
                }
              })
            })
          }
        }
        if (typeof this.data.theme === 'undefined' || this.data.theme === null) {
          this.$vuetify.theme.dark = false
        } else if (this.data.theme === 3) {
          this.$vuetify.theme.dark = window.matchMedia('(prefers-color-scheme: dark)').matches
        } else if (this.data.theme === 1) {
          this.$vuetify.theme.dark = false
        } else {
          this.$vuetify.theme.dark = true
        }
      }
    },
    version () {
      const v = localStorage.version ? localStorage.version : null
      if (this.version !== v) {
        // console.log('system has been updated')
        localStorage.version = this.version
      }
    },
    unRead () {
      this.setTitle()
    },
    schools () {
      this.changeGrade(this)
    }
  },
  created () {
    this.setTitle()
    this.$store.dispatch('shared/setLoading', true)
    this.monitor()
    moment.tz.setDefault('Asia/Tokyo')
    var y = this.getFY() - 2018 + 2
    var temp = []
    for (var i = 0; i < y; i++) {
      temp.push({
        key: i + 1,
        name: String(2018 + i),
        value: 2018 + i
      })
    }
    Vue.prototype.$YEARS = temp

    y = this.getFY() - 2018 + 2
    temp = []
    for (i = 0; i < y; i++) {
      temp.push({
        key: i + 1,
        name: String(2018 + i),
        value: 2018 + i
      })
    }
    Vue.prototype.$YEARS_PLANS = temp

    const v = localStorage.version ? localStorage.version : null
    if (this.version !== v) {
      // console.log('system has been updated')
      localStorage.version = this.version
    }
    var vm = this
    firebase.auth().onAuthStateChanged((payload) => {
      var user = JSON.parse(JSON.stringify(payload))
      if (user) {
        if (this.isMaintenance) {
          this.$store.dispatch('auth/readUser', user).then(function (resp) {
            if (resp.role !== 'admin') {
              firebase.auth().signOut()
            } else {
              vm.checkVerified(user)
            }
          })
        } else {
          vm.checkVerified(user)
        }
      } else {
        vm.$store.dispatch('shared/setLoading', false)
      }
    })
  },
  methods: {
    setTitle () {
      var favicon
      if (this.checkServer()) {
        const head = document.querySelector('head')
        head.insertAdjacentHTML('afterBegin', '<meta name="google-site-verification" content="h2ZI1K25b0FkrSiAlse292xiZ_0OoYQ5HhoQ_e2yw7k">')
      }
      if (this.unRead !== 0) {
        document.title = '(' + String(this.unRead) + ') ' + '⼈が育つ教室経営システム'
        favicon = document.getElementById('favicon')
        favicon.outerHTML = '<link rel="icon" id="favicon" href="favicon-2.ico">'
      } else {
        document.title = '⼈が育つ教室経営システム'
        favicon = document.getElementById('favicon')
        favicon.outerHTML = '<link rel="icon" id="favicon" href="favicon.ico">'
      }
      // }
    },
    checkMember (ref) {
      if (ref.type === 'group') {
        if (typeof this.data.groups[ref.key] !== 'undefined') {
          return this.data.groups[ref.key]
        } else {
          return false
        }
      } else if (ref.type === 'school') {
        if (typeof this.data.schools[ref.key] !== 'undefined') {
          return this.data.schools[ref.key]
        } else {
          return false
        }
      }
      return true
    },
    checkVerified (user) {
      var vm = this
      this.presence(user.uid)
      if (user.emailVerified) {
        this.$store.dispatch('auth/getUser', user).then(function (resp) {
          vm.$store.dispatch('auth/subscribe').then(() => {
            if (resp === null) {
              vm.$store.dispatch('auth/get', vm.getSchool()).then(() => {
                vm.$store.dispatch('shared/setLoading', false)
                vm.goto(vm, '/')
              })
            } else {
              vm.$store.dispatch('shared/setLoading', false)
            }
          })
        })
      }
    },
    checkNotice (item) {
      if (item.path === '/notice') {
        return this.data.notice
      } else {
        return true
      }
    },
    checkAvailable (item) {
      if (!this.isUserAuthenticated) {
        return true
      }
      if (this.checkPrimary()) {
        return !item.primary
      }
      if (item.disable) {
        return true
      }
      if (item.path === '/drive' && this.data.docs) {
        return true
      }
      if (item.path === '/diagnose') {
        if (typeof this.data.diag !== 'undefined') {
          return this.data.diag
        }
        return false
      }
      // if (item.path === '/diagnose' && this.data.role === 'admin') {
      //   return true
      // }
      if (item.path === '/schedule') {
        return this.checkPrivileges('plan')
      }
      if (this.data && item.roles[this.getPrivilege(this.data)]) {
        return true
      }
      return false
    },
    checkPrimary () {
      if (this.data && typeof this.data.schools !== 'undefined') {
        var keys = Object.keys(this.data.schools)
        for (var i in keys) {
          if (this.data.schools[keys[i]]) {
            if (keys[i] !== this.data.primary) {
              return true
            }
          }
        }
      }
      return false
    },
    checkSchoolAvatar () {
      if (this.data && typeof this.data.schools !== 'undefined') {
        var keys = Object.keys(this.data.schools)
        for (var i in keys) {
          if (this.data.schools[keys[i]]) {
            var index = this.schools.findIndex(s => s.key === keys[i])
            if (index !== -1) {
              if (this.schools[index].avatar) {
                return this.schools[index].avatar.thumbnail
              }
            }
          }
        }
      }
      return null
    },
    getNamePrefixFromItem () {
      var name = '？'
      if (this.data && typeof this.data.schools !== 'undefined') {
        var keys = Object.keys(this.data.schools)
        for (var i in keys) {
          if (this.data.schools[keys[i]]) {
            var index = this.schools.findIndex(s => s.key === keys[i])
            if (index !== -1) {
              name = this.schools[index].name.slice(0, 1)
            }
          }
        }
      }
      return name
    },
    getPrimaryColor (item) {
      if (this.$route.path === item.path) {
        if (this.data && this.getPrivilegesLevel(this.data) === 0) {
          return 'secondary'
        }
        if (this.checkPrimary()) {
          return 'error'
        }
        return 'primary'
      } else {
        return 'grey'
      }
    },
    getSchool () {
      if (this.data && this.getPrivilegesLevel(this.data) === 0 && this.data.root) {
        return null
      }
      return localStorage.school
    },
    onResize () {
      var windowSize = { x: window.innerWidth, y: window.innerHeight }
      this.$store.dispatch('shared/setWindowSize', windowSize)
    },
    presence (uid) {
      var userStatusFirestoreRef = firebase.firestore().doc('/status/' + uid)
      var userStatusDatabaseRef = firebase.database().ref('/status/' + uid)
      var isOfflineForFirestore = {
        state: 'offline',
        last_changed: firebase.firestore.FieldValue.serverTimestamp()
      }
      var isOnlineForFirestore = {
        state: 'online',
        last_changed: firebase.firestore.FieldValue.serverTimestamp()
      }
      var isOfflineForDatabase = {
        state: 'offline',
        last_changed: firebase.database.ServerValue.TIMESTAMP
      }
      var isOnlineForDatabase = {
        state: 'online',
        last_changed: firebase.database.ServerValue.TIMESTAMP
      }
      firebase.database().ref('.info/connected').on('value', function (snapshot) {
        if (snapshot.val() === false) {
          userStatusFirestoreRef.set(isOfflineForFirestore)
          return
        }
        userStatusDatabaseRef.onDisconnect().set(isOfflineForDatabase).then(function () {
          userStatusDatabaseRef.set(isOnlineForDatabase)
          userStatusFirestoreRef.set(isOnlineForFirestore)
        })
      })
      firebase.auth().onAuthStateChanged(function (user) {
        if (!user) {
          userStatusDatabaseRef.set(isOfflineForDatabase)
          userStatusFirestoreRef.set(isOfflineForFirestore)
        }
      })
      document.addEventListener('visibilitychange', function () {
        if (firebase.auth().currentUser !== null) {
          if (document.visibilityState === 'visible') {
            userStatusDatabaseRef.set(isOnlineForDatabase)
            userStatusFirestoreRef.set(isOnlineForFirestore)
          } else {
            userStatusDatabaseRef.set(isOfflineForDatabase)
            userStatusFirestoreRef.set(isOfflineForFirestore)
          }
        } else {
          userStatusDatabaseRef.set(isOfflineForDatabase)
          userStatusFirestoreRef.set(isOfflineForFirestore)
        }
      })
    },
    monitor () {
      var vm = this
      firebase.database().ref('/system/maintenance').once('value').then(function (snapshot) {
        vm.$store.dispatch('shared/setMaintenance', snapshot.val())
      })
      if (!this.doingMonitor) {
        firebase.database().ref('/system/maintenance').on('value', function (snapshot) {
          vm.$store.dispatch('shared/setMaintenance', snapshot.val())
          vm.doingMonitor = true
        })
      }
    },
    onGotoHome () {
      window.open('http://freewill.education/', '_blank')
    },
    onGoto (path) {
      this.goto(this, path)
    },
    onDismissed: function (value) {
      if (this.tospp) {
        this.tospp = false
        return
      }
      if (this.dialog) {
        this.dialog = false
        if (value) {
          this.onLogout()
        }
      }
    },
    // onLogoutDialog () {
    //   this.dialog = true
    // },
    onLogout () {
      var vm = this
      if (this.data) {
        vm.goto(vm, '/')
        this.$nextTick(function () {
          vm.gisSignOut()
          vm.$store.dispatch('auth/release').then(() => {
            vm.goto(vm, '/')
          })
        })
      }
    }
  }
}
</script>

<style>

html { overflow-y: auto }

 .overflow-text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  user-select: none !important;
}

.v-icon {
  user-select: none !important;
}

.sheet-footer-text {
  user-select: none !important;
}

@media print {
  /* @page { margin: 0; }
  body {
    -webkit-print-color-adjust: exact;
    margin: 1cm;
    overflow-y: visible !important;
    height: 100%;
  }
  .v-btn {
    display: none;
  } */
  .no-print {
    display: none;
  }
  /* .scroll-y {
     height: auto;
     overflow: visible;
  } */
}

</style>
